import { eventsConst } from '../consts';
import { eventsService } from '../services/events.service';
import { processFailure } from './utils';

export const eventsActions = {
    getAll,
};

function getAll() {
    return (dispatch) => {
        dispatch(request());

        eventsService.getAll().then(
            (events) => {
                dispatch(success(events));
            },
            (error) => onError(error, dispatch)
        );
    };

    function request() {
        return { type: eventsConst.EVENTS_REQUEST };
    }
    function success(events) {
        return { type: eventsConst.EVENTS_SUCCESS, events };
    }
    function onError(error, dispatch) {
        processFailure({
            dispatch,
            error,
            action: {
                type: eventsConst.EVENTS_FAILURE,
            },
        });
    }
}
